import { formatTaskCategoryName } from 'utils/constants/task';
import { TASK_MODEL } from '../../../services/entity/task';
import { DEFAULT_EMPTY_VALUE } from '../../constants/index';
import { getItemOrDefaultToValue } from '../../details/index';

export const SUB_TASK_COLUMNS = {
  taskImage: {
    headerName: 'Image',
    field: 'taskImage',
  },
  name: {
    headerName: TASK_MODEL.taskName.label,
    field: TASK_MODEL.taskName.id,
  },
  description: {
    headerName: TASK_MODEL.description.label,
    field: TASK_MODEL.description.id,
  },
  evidence: {
    headerName: TASK_MODEL.evidence.label,
    field: TASK_MODEL.evidence.id,
  },
  expectedDuration: {
    headerName: TASK_MODEL.expectedDuration.label,
    field: TASK_MODEL.expectedDuration.id,
  },
};

export const transformFormViewSubTask = data => {
  return data.map(item => {
    return {
      rowData: {
        taskImage: item.taskImage
          ? {
              type: 'image',
              value: item.taskImage,
            }
          : DEFAULT_EMPTY_VALUE,
        // additionalMarkers: item.additionalMarkers,
        [TASK_MODEL.taskName.id]: getItemOrDefaultToValue(
          item,
          'taskName',
          DEFAULT_EMPTY_VALUE,
        ),
        [TASK_MODEL.description.id]: getItemOrDefaultToValue(
          item,
          'taskDescription',
          DEFAULT_EMPTY_VALUE,
        ),
        [TASK_MODEL.evidence.id]: item[TASK_MODEL.evidence.id]
          ? {
              type: 'evidence-array',
              value: item[TASK_MODEL.evidence.id].map(ev => {
                return {
                  description: {
                    ...ev.description,
                    header: TASK_MODEL.evidence.description.label,
                  },
                  type: { ...ev.type, header: TASK_MODEL.evidence.type.label },
                };
              }),
            }
          : DEFAULT_EMPTY_VALUE,
        [TASK_MODEL.expectedDuration.id]: getItemOrDefaultToValue(
          item,
          TASK_MODEL.expectedDuration.id,
          DEFAULT_EMPTY_VALUE,
        ),
      },
      allowEdit: true,
      allowDelete: true,
      rawData: item,
    };
  });
};

export const transformFormViewRootTask = data => {
  return data.map(item => {
    const [rootTask] = item.tasks.filter(f => f.id === item.rootTaskId);

    const noOfEvidences =
      rootTask?.evidence && rootTask.evidence.length > 0
        ? rootTask.evidence.length
        : DEFAULT_EMPTY_VALUE;

    return {
      rowData: {
        [TASK_MODEL.taskType.id]: formatTaskCategoryName(
          getItemOrDefaultToValue(rootTask, 'taskType', DEFAULT_EMPTY_VALUE),
        ),
        [TASK_MODEL.taskName.id]: getItemOrDefaultToValue(
          rootTask,
          'name',
          DEFAULT_EMPTY_VALUE,
        ),
        [TASK_MODEL.status.id]: getItemOrDefaultToValue(
          rootTask,
          'status',
          DEFAULT_EMPTY_VALUE,
        ),
        [TASK_MODEL.description.id]: getItemOrDefaultToValue(
          rootTask,
          'description',
          DEFAULT_EMPTY_VALUE,
        ),
        [TASK_MODEL.evidence.id]: noOfEvidences,
      },
      allowEdit: true,
      allowDelete: true,
      rawData: item,
    };
  });
};
